export class EdeMemberId{
  constructor(
    public id?: number,
    public memberId?: string,
    public customerId?: string
  ) { }
}
